import React from "react";
import Member from "./Member";

export default class MemberList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedResource: this.props.selectedResources };
    this.selectResource = this.selectResource.bind(this);
    this.strings = this.props.strings;
  }

  selectResource = (e, member) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    this.props.selectedResource(member);
  };

  render() {
    const { members, isLoading } = this.props;
    let list;

    if (isLoading) {
      return (
        <div className="list--loading">
          <p>{`${this.strings.loading}`}</p>
        </div>
      );
    }

    if (members.length > 0 && !isLoading) {
      list = (
        <ul className="list">
          {members.map((member) => (
            <Member member={member} selectResource={this.selectResource} />
          ))}
        </ul>
      );
    } else {
      list = (
        <div className="list--no-results">
         <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
            <path d="M22.05 23q-3.15 0-5.35-2.2-2.2-2.2-2.2-5.3 0-3.15 2.2-5.325Q18.9 8 22 8q3.15 0 5.325 2.175Q29.5 12.35 29.5 15.45q0 3.15-2.175 5.35Q25.15 23 22.05 23ZM22 20q1.9 0 3.2-1.325 1.3-1.325 1.3-3.175 0-1.9-1.3-3.2-1.3-1.3-3.15-1.3-1.9 0-3.225 1.3-1.325 1.3-1.325 3.15 0 1.9 1.325 3.225Q20.15 20 22 20Zm22.9 27-7-7q-1.15.85-2.375 1.175Q34.3 41.5 33 41.5q-3.55 0-6.025-2.475Q24.5 36.55 24.5 33q0-3.55 2.475-6.025Q29.45 24.5 33 24.5q3.55 0 6.025 2.475Q41.5 29.45 41.5 33q0 1.3-.325 2.525Q40.85 36.75 40 37.9l7 7ZM33 38.5q2.35 0 3.925-1.575Q38.5 35.35 38.5 33q0-2.35-1.575-3.925Q35.35 27.5 33 27.5q-2.35 0-3.925 1.575Q27.5 30.65 27.5 33q0 2.35 1.575 3.925Q30.65 38.5 33 38.5ZM6 40v-4.7q0-1.85.875-3.15Q7.75 30.85 9.4 30q2.35-1.15 6.125-2.175t7.675-.775q-.4.65-.75 1.425T21.9 30q-3.9-.05-6.8.925-2.9.975-4.5 1.775-.7.4-1.15 1.075Q9 34.45 9 35.3V37h12.9q.55.85 1 1.575.45.725 1 1.425Zm16-24.5ZM21.9 37Z"/>
          </svg>
          <p>{`${this.strings.no_results}`}</p>
          <p>
            {`${this.strings.all_members}`}
            <button
              className="btn btn-primary btn-danger"
              onClick={() =>
                this.props.handleActiveMembersToggle(
                  { target: { checked: false } },
                  true
                )
              }
            >{`${this.strings.all_members_button}`}</button>
          </p>
        </div>
      );
    }

    return list;
  }
}
